import { render, staticRenderFns } from "./emailTemplate.vue?vue&type=template&id=481fe250&scoped=true&"
import script from "./emailTemplate.vue?vue&type=script&lang=js&"
export * from "./emailTemplate.vue?vue&type=script&lang=js&"
import style0 from "./emailTemplate.vue?vue&type=style&index=0&id=481fe250&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481fe250",
  null
  
)

export default component.exports